// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4931) return "css/4931.1f0039a0d71c2f95dbc8.css";
	// return url for filenames based on template
	return "css/" + "common" + "." + "16d115d82043d1458e22" + ".css";
};